import { Component, Input } from '@angular/core';
import { ModalController, NavParams } from 'ionic-angular';
import { ResultEditKoPage } from '../../edits/ko-page/edit-ko';

@Component({
  selector: 'result-ko',
  templateUrl: 'result-ko.html',
})
export class GamerResultKoPage {
  tab: string = 'overview';

  @Input() activePlan: any = 0;
  @Input() header: boolean = true;

  constructor(
    private navParams: NavParams,
    private modalCtrl: ModalController
  ) { 
    this.activePlan = this.navParams.get('activePlan') || this.activePlan;
    
  }

  ionViewDidLoad() { }

  onEditTeam(teamIndex: any) {
    let modal = this.modalCtrl.create(ResultEditKoPage, { activePlan: this.activePlan, teamIndex: teamIndex });
    modal.present();
  }
}

export interface IGamePlan {
  id: number;
  gameDay: number;
  name: string;
  team1: {
    id: number;
    name: string;
  };
  team2: {
    id: number;
    name: string;
  }
}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/results/result-ko/result-ko.ts